<template>
  <el-card shadow="never">
    <div class="header">
      <el-breadcrumb class="breadcrumb" separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
          <el-breadcrumb-item>产品分类列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="primary" class="editbtn" @click="showCatesBox" style="margin-right:10px">添加产品分类</el-button>
    </div>
  </el-card>
  <el-card shadow="never" style="margin-top:20px">
    <el-tree
        ref="treeRef"
        class="filter-tree"
        :expand-on-click-node="false"
        :data="baseData.datalist"
        :props="defaultProps"
        default-expand-all
    >
      <template #default="{ data }">
        <span class="custom-tree-node">
          <span>{{ data.title }}</span>
          <span>
            <el-button type="success" size="small" @click="showEidtCatesBox(data)" style="margin-right:10px">编辑</el-button>
            <el-popconfirm
                confirm-button-text="是"
                cancel-button-text="否"
                title="确定删除吗?"
                @confirm="del_cate(data.id)"
              >
                <template #reference>
                  <el-button size="small" type="danger">删除</el-button>
                </template>
              </el-popconfirm>
          </span>
        </span>
      </template>
    </el-tree>
  </el-card>

  <el-dialog v-model="baseData.catesbox" :title="baseData.title">
    <el-form :model="formData" label-width="120">
      <el-form-item label="分类名称">
        <el-input v-model="formData.catagory_name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="所属公司">
        <el-select
            v-model="formData.companyid"
            placeholder="请选择"
            >
            <el-option
                v-for="item in baseData.companylist"
                :key="item.id"
                :label="item.title"
                :value="item.id"
            />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="上级分类">
        <el-cascader
          v-model="formData.parentid"
          :options="baseData.datalist"
          :props="propss"
          :show-all-levels="false"
          filterable
          clearable
          @change="handleChange"
        />
      </el-form-item> -->
      <el-form-item label="图标">
        <el-row class="martop">
          <el-upload
            class="avatar-uploader"
            action=""
            :http-request="uploadImg"
            :show-file-list="false"
          >
            <img v-if="formData.img" :src="formData.img" class="avatar" />
            <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
          </el-upload>
        </el-row>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="baseData.catesbox = false">取消</el-button>
        <el-button type="primary" @click="save">提交</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import { reactive, onMounted } from 'vue'
import { ElMessage, ElLoading } from 'element-plus'
import api from '@/api/index'
import {useRouter} from 'vue-router'

const router = useRouter()
const propss = {
  expandTrigger: 'hover' as const,
  value:'id',
  label:'title',
  children:'children',
}
const searchForm = reactive({
  words:"",
  limit:1000,
  page:1,
})
const baseData:any = reactive({
  loading:false,
  userbox:false,
  datalist:[],
  companylist:[],
  catesbox:false,
  title:'新建产品分类',
})
const formData = reactive({
  catagory_name:'',
  parentid:'',
  catagoryid:'',
  companyid:'',
  img:'',
  sort:'',
})
const showCatesBox = () => {
  baseData.catesbox = true
  baseData.title = '新建产品分类'
  formData.catagory_name = ''
  formData.companyid = ''
  formData.parentid = ''
  formData.catagoryid = ''
  formData.sort = ''
}
const showEidtCatesBox = (data:any) => {
  baseData.catesbox = true
  baseData.title = '编辑产品分类'
  formData.catagory_name = data.title
  formData.parentid = data.parentid ? data.parentid : ''
  formData.companyid = data.companyid ? data.companyid : ''
  formData.catagoryid = data.id
  formData.sort = data.Sort
}
const handleChange = (value:any) => {
  formData.parentid = value[value.length-1]
}
const uploadImg = (params:any) => {
  const loading = ElLoading.service({lock: true})
  const file = params.file,formData1 = new FormData();
  formData1.append("file", file)
  api.commonApi.uploadImg(formData1).then((res:any)=>{
    loading.close()
      if(res.code == 200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        formData.img = res.data.img
      }else{
        ElMessage.error(res.message)
      }
  })
}
const save = () => {
  baseData.loading = true
  if(formData.catagoryid){
    api.goodsApi.edit_cate(formData).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.catesbox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }else{
    api.goodsApi.add_cate(formData).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.catesbox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
}
const del_cate = (id:number) => {
  api.goodsApi.del_cate({catagoryid:id}).then((res:any)=>{
    if(res.code==200){
      ElMessage({
        message: res.message,
        type: 'success',
      })
      getList()
    }else{
      ElMessage.error(res.message)
    }
  })
}
const getList = () => {
  baseData.loading = true
  api.goodsApi.get_cates_list(searchForm).then((res:any)=>{
    baseData.loading = false
    if(res.code==200){
      baseData.datalist = res.data.list
    }else{
      ElMessage.error(res.message)
    }
  })
}
const getCompanyList = () => {
    baseData.loading = true
    api.companyApi.list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.companylist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
const defaultProps = {
  children: 'children',
  label: 'title',
}
onMounted(() => {
  getList()
  getCompanyList()
})
</script>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-tree-node__content{
  height: 40px;
}
</style>